import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
  /**
   * 取得儲值方案
   */
  fetchDeposit({ commit }) {
    return request
      .post(`/merchant/deposit/search`, {
        paginate: 0,
      }, {
        ...configRequest,
        name: 'fetchDeposit',
      })
      .then((response) => response.items)
  },
};
